<template>
    <div>
        <van-form v-show="!isNext">
            <van-field label="原手机号" :value="$store.state.userInfo.phone_desensitization" readonly />
            <van-field v-model="verification_code" center clearable label="短信验证码" placeholder="请输入短信验证码">
                <template #button>
                    <van-button size="small" type="primary" @click="sendOriginalSms" :disabled="!!send_interval">{{send_interval ? send_interval + 's后重试' : '发送验证码'}}</van-button>
                </template>
            </van-field>
            <van-button type="primary" block style="margin-top: 20px;" @click="next">下一步</van-button>
        </van-form>
        <div v-show="isNext">
            <div style="font-size: 18px; text-align: center; padding: 30px 0 10px 0;">设置支付密码</div>
            <div style="text-align: center; color: #888888; padding: 10px;">{{paymentPassword === '' ? '请设置新密码，用于新密码支付' : '请再次输入设置新支付密码，用于确认支付密码'}}</div>
            <van-password-input :value="password" :focused="showPaymentPasswordKeyboard" @focus="showPaymentPasswordKeyboard = true" />
            <van-number-keyboard v-model="password" :show="showPaymentPasswordKeyboard" :maxlength="6" />
        </div>
    </div>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: "ForgetPaymentPassword",
        data(){
            return {
                verification_code:'',
                send_interval : null,
                password : '',
                showPaymentPasswordKeyboard : true,
                showPaymentPassword : false,
                paymentPassword : '',
                confirmPaymentPassword : '',
                isNext : false,
            };
        },
        watch : {
            password(newValue, oldValue){
                if(newValue.length >= 6){
                    let self = this;
                    if(this.paymentPassword === '' && this.confirmPaymentPassword === ''){
                        this.paymentPassword = newValue;
                        this.password = '';
                    }else if(this.paymentPassword !== '' && this.confirmPaymentPassword === ''){
                        this.confirmPaymentPassword = newValue;
                        if(this.paymentPassword !== this.confirmPaymentPassword){
                            this.password = this.paymentPassword = this.confirmPaymentPassword = '';
                            this.$notify({ type: 'danger', message: '两次输入的支付密码不一致，请重新输入' });
                        }else{
                            api.request('/user/forget_payment_password', {
                                payment_password : this.paymentPassword,
                                confirm_payment_password : this.confirmPaymentPassword,
                                verification_code : this.verification_code,
                            }).then(res => {
                                self.$notify({ type: 'success', message: res.msg });
                                self.$router.back();
                            }).catch(res => {
                                self.$notify({ type: 'danger', message: res.msg });
                                self.password = self.paymentPassword = self.confirmPaymentPassword = '';
                                self.isNext = false;
                            });
                        }
                    }
                }
            }
        },
        methods : {
            sendOriginalSms(){
                let self = this;
                api.request('/common/send_bind_phone_sms_verification_code', {
                    'type' : 'forget_payment_password',
                }).then(res => {
                    self.send_interval = res.data.send_interval;
                    let setSmsTimer = setInterval(function () {
                        self.send_interval--;
                        if(self.send_interval <= 0){
                            clearInterval(setSmsTimer);
                            self.send_interval = null;
                        }
                    }, 1000);
                    self.$toast(res.msg);
                }).catch(res => {
                    self.$toast(res.msg);
                });
            },
            next(){
                let self = this;
                api.request('/common/check_bind_phone_sms_verification_code', {
                    'verification_code' : self.verification_code,
                    'type' : 'forget_payment_password',
                }).then(res => {
                    self.isNext = true;
                }).catch(res => {
                    self.$toast(res.msg);
                });
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/ForgetPaymentPassword.vue